export default {
    doing: 'doing',
    manage: 'manage',
    setting: 'setting'
};



// WEBPACK FOOTER //
// ./src/js/appMode.js